import React, { createContext, useMemo, useState } from "react";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";

export const ColorModeContext = createContext({ toggleColorMode: () => {} });

export default function ThemeContextProvider({ children }) {
  const [mode, setMode] = useState(localStorage.getItem("theme") || "light");

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => {
          const newMode = prevMode === "light" ? "dark" : "light";
          localStorage.setItem("theme", newMode);
          return newMode;
        });
      },
    }),
    []
  );

  // 2026-10-22 fix — real, confirmed bug: with no explicit `primary` color,
  // MUI's dark-mode default (a LIGHT blue, #90caf9) auto-computes DARK
  // contrastText — but every "contained" button in this app (Sign In,
  // Create & Email Credentials, etc.) overrides its own `background` via
  // sx to the brand's dark navy gradient, which doesn't lighten in dark
  // mode. The themed contrastText (still dark, following MUI's own light-
  // primary default) rendered as near-black text on a dark navy button —
  // measured ~rgb(0,4,10) text on ~rgb(0,24,58) background in dark mode,
  // a real legibility failure, not a design preference. Pinning `primary`
  // to the brand navy in both modes makes MUI's own auto-contrast
  // correctly resolve to white, matching what every custom-background
  // button here actually needs.
  const theme = useMemo(() => createTheme({
    palette: { mode, primary: { main: "#00357a", contrastText: "#ffffff" } },
  }), [mode]);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}
